import React from 'react'

import './navbar.css'

function Navbar() {
  return (
    <div className='navbarStyle'>
        <h3 className='title'>Crypto Dashboard</h3>
    </div>
  )
}

export default Navbar